mutation deleteLead($id: String!) {
  response: deleteLead(id: $id)
}
